import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_regular,
  font_size_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const list = css`
  list-style: none;
`

export const loadMore = css`
  display: flex;
  justify-content: center;
  padding-top: ${spacing(3)};
`

/**
 * Announced but not seen. `clip-path` plus a 1px box is the standard
 * visually-hidden recipe: `display: none` and `visibility: hidden` both remove
 * the element from the accessibility tree, which would silence the live region
 * this is for.
 */
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
`

/* The message keeps its own vertical padding; only the retry control below it
   needs spacing, and the block needs to stay centred like every other state. */
export const errorState = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  > p {
    padding-bottom: ${spacing(2)};
  }
`

export const message = css`
  padding: ${spacing(6)} ${spacing(2)};
  text-align: center;
  font-size: ${font_size_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
`
